import Swiper from 'swiper';

class ProductSlider {
  public triggers;

  constructor() {
    this.triggers = document.querySelectorAll(
      '[data-trigger="slider-product"]'
    );
    this._init();
  }

  private _init() {
    if (this.triggers) {
      this.triggers.forEach((trigger) => {
        const swiper = new Swiper(trigger, {
          slidesPerView: 'auto',
          spaceBetween: 30
        });
      });
    }
  }
}

export const productSlider = new ProductSlider();
